module.exports = __webpack_public_path__ + "img/tip4.099f389b.png";